// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federbeanspruchung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federbeanspruchungDE: PageEntry = {
  id: "post.federbeanspruchung",
  locale: "de",
  slug: "federbeanspruchung",
  seo: {
    title: "Glossar: Federbeanspruchung einfach erklärt | Dietz GmbH",
    description: "Die Federbeanspruchung beschreibt die auf eine Feder wirkenden Kräfte und Belastungen. Federn werden typischerweise gedehnt oder komprimiert, wodurch sie beansprucht werden. Die Be",
  },
  type: "post",
  h1: "Glossar: Federbeanspruchung einfach erklärt",
  intro: "Die Federbeanspruchung beschreibt die auf eine Feder wirkenden Kräfte und Belastungen. Federn werden typischerweise gedehnt oder komprimiert, wodurch sie beansprucht werden. Die Beanspruchung einer Feder hängt von Faktoren wie der Last, der Federkonstanten und der Federgeometrie ab. Eine präzise Berechnung und Analyse der Beanspruchung ist entscheidend, um eine sichere und effiziente Funktion der Feder in einem bestimmten System zu gewährleisten. Die Auswahl des richtigen Federmaterials spielt ebenfalls eine wichtige Rolle bei der Bewältigung unterschiedlicher Beanspruchungen.",
  blocks: [

  ],
};
